import { BookerInfo } from './../../../model/checkout/booker-info.model';
import { AdditionalTravellerDetail, GuestInfo } from '../../../model/checkout/guest-info.model';
import { CartLineItemsModel } from 'app/model/checkout/cart-info-model';

export class CreateOrderPayload {
  searchId: String;
  lineItems: CartLineItemsModel[];
  lang: string;
  bookerInfo: CreateOrderBookerInfo[];
  guestInfo: GuestInfo[];
  guestsBookerTravellerInfo: GuestInfo[];
  arrivalTime: string;
  isBookForTraveller?: boolean = false;
  verifiedToken?: string;
  discounts?: Discount[];
  getBookerByEmail(email: string) {
    return this.bookerInfo.find(item => item.email.toLowerCase() === email.toLowerCase());
  }
}

export class CreateOrderBookerInfo {
  bookerCurrency: string;
  fullName: string;
  firstName: string;
  lastName: string;
  mobileNumber: string;
  email: string;
  companyId: number;
  paymentCreditCard: BookerPaymentCreditCard;
  paymentCreditTerms: BookerPaymentCreditTerms;
  paymentTrueMoney: BookerTrueMoney;
  paymentCorporateFleetCard: PaymentFleetCard;
  paymentPersonalFleetCard: PaymentFleetCard;
  paymentQRCode: BookerPaymentQRCode;
  paymentEWallet: BookerPaymentEWallet;
  paymentIMBanking: BookerPaymentIMBanking;
  paymentPayAtCounter: BookerPaymentPayAtCounter;
  countryISO2: string;
  countryCallingCode: string;
  userId: number;
  additionalTravellerDetails: AdditionalTravellerDetail[];
  totalCharge?: number;

  constructor(bookerInfo: BookerInfo) {
    this.bookerCurrency = bookerInfo.bookerCurrency;
    this.fullName = bookerInfo.fullName;
    this.firstName = bookerInfo.firstName;
    this.lastName = bookerInfo.lastName;
    this.mobileNumber = bookerInfo.mobileNumber;
    this.email = bookerInfo.email;
    this.countryISO2 = bookerInfo.countryISO2;
    this.countryCallingCode = bookerInfo.countryCallingCode;
  }
}

export class BookerPaymentQRCode {
  taxAddress: TaxAddress;
  totalAmount: number;
  gatewayId: number;
}

export class BookerPaymentEWallet {
  taxAddress: TaxAddress;
  totalAmount: number;
  gatewayId: number;
}

export class BookerPaymentIMBanking {
  taxAddress: TaxAddress;
  totalAmount: number;
  gatewayId: number;
}

export class BookerPaymentPayAtCounter {
  taxAddress: TaxAddress;
  totalAmount: number;
  gatewayId: number;
}

export class BookerTrueMoney {
  taxAddress: TaxAddress;
  totalAmount: number;
  accountNumber: number;
  gatewayId: number;
}

export class BookerPaymentCreditCard {
  taxAddress: TaxAddress;
  cardHolderName: string;
  encryptedCardInfo: string;
  maskedCardInfo: string;
  expMonthCardInfo: string;
  expYearCardInfo: string;
  gatewayId: number;
  totalAmount: number;
}

export class BookerPaymentCreditTerms {
  ch3CustomFields: Ch3CustomFields[];
  taxAddress: TaxAddress;
  attachmentPath: string[];
  totalAmount: number;
}

export class Ch3CustomFields {
  fieldId: string;
  value: string;
  constructor (fieldId: string, value: string) {
    this.fieldId = fieldId;
    this.value = value;
  }
}

export class TaxAddress {
  taxAddress: string;
  taxId: string;
  taxName: string;
}

export class CostCenter {
  costCenterCode?: string;
  costCenterName?: string;
}

export class InternalOrder {
  internalOrderCode?: string;
  internalOrderName?: string;
}

export class CreateOrderPayloadWithPromotion extends CreateOrderPayload {
  promotion: Promotion = new Promotion();
}

export class Promotion {
  bookerEmail: string;
  promotionCode: PromotionCode = new PromotionCode;
}

export class PromotionCode {
  code: String;
  destination: String;
  companyId: Number;
}

export class OneTimeTaxAddress {
  taxAddress: string;
  taxId: string;
  taxName: string;
}

export class PaymentFleetCard {
  fleetCardId: string;
  totalAmount: number

  constructor(fleetCardId: string, totalAmount: number) {
    this.fleetCardId = fleetCardId;
    this.totalAmount = totalAmount;
  }
}

export class Discount {
  discountType: string;
  referenceCode: string;
  discountAmount: number;
}



// WEBPACK FOOTER //
// ./src/app/services/checkout/payload/create-order.payload.ts